<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style ">
            <li class="breadcrumb-item">
              <h4 class="page-title">Basic Form</h4>
            </li>
            <li class="breadcrumb-item bcrumb-1">
              <a routerLink="/dashboard/main">
                <i class="fas fa-home"></i> Home</a>
            </li>
            <li class="breadcrumb-item bcrumb-2">
              <a href="#" onClick="return false;">Forms</a>
            </li>
            <li class="breadcrumb-item active">Basic</li>
          </ul>
        </div>
      </div>
    </div>
    <app-maser-page-header></app-maser-page-header>
    <div class="row" style="    margin-top: 25px;">

      <div class="col">
        <div class="form-row">
          <label>Session <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
          <select class="form-control" #session_id>
            <option *ngFor="let session of sessions" [value]="session['id']">{{session['name']}} </option>
          </select>
        </div>
      </div>

      <div class="col">
        <label>Route <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
        <select class="form-control" #route_code>
          <option *ngFor="let route of routes[session_id.value]" [value]="route['id']">{{route['name']}}
          </option>
        </select>
        <!-- <input type="text" class="form-control" #route_code placeholder="Route id"> -->
      </div>



      <div class="col">
        <mat-form-field>
          <mat-label>Choose a date</mat-label>
          <input matInput [matDatepicker]="picker" #date>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-1">
        <button mat-raised-button (click)="getData(route_code.value, date.value, session_id.value)"> Submit
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col text-center">
        <div>The Coimbatore District C0-operative Milk Producers Union Lts.,</div>
        <div>Pachapalayam, Coimbatore - 6410 010</div>
      </div>
    </div>
    <div class="row">
      <div class="col" style="text-align: center;text-decoration: underline;">
        ARCAWISE MILK DISTRIBUTION STATEMENT
      </div>

    </div>
    <div *ngIf="report_data != null">
      <div class="row">
        <div class="col">
          <div><b>Route Name : </b>{{ report_data['route_name'] }}</div>
          <div><b>Vehicle Name : </b>{{ report_data['vehicle_number'] }}</div>
        </div>
        <div class="col" style="text-align: right;">
          <div>Date : {{ selected_date }} / {{  report_data['session_name']  }}</div>
          <div>Departure Time :</div>
        </div>
      </div>
      <div>
        <div class="row" style="font-weight: 600;border: 1px solid grey;padding: 10px;">
          <div class="col">#</div>
          <div class="col">Booth</div>
          <div class="col">Agent</div>
          <div class="col" *ngFor="let product of products"> {{ product['short_name'] }} </div>
        </div>
        <span *ngFor="let booth_type of booth_types;let business_index=index">
          <div class="row" *ngFor="let business_id of report_data['booth_types'][booth_type]['booth_ids']"
            style="padding: 10px;">
            <div class="col">{{business_index}}</div>
            <div class="col">{{ report_data['booth_types'][booth_type][business_id]['business_code'] }}
            </div>
            <div class="col">
              {{ report_data['booth_types'][booth_type][business_id]['agent_name'] | slice:0:7}}</div>
            <div class="col" *ngFor="let product of products">
              <span *ngIf="report_data['booth_types'][booth_type][business_id]['product'].hasOwnProperty(product.id)">
                {{ report_data['booth_types'][booth_type][business_id]['product'][product['id']] }}
              </span>
              <span *ngIf="!report_data['booth_types'][booth_type][business_id]['product'].hasOwnProperty(product.id)">
                0
              </span>
            </div>
          </div>
        </span>
      </div>
    </div>
  </div>
</section>
